type SourceItem = {
  integration_credential?: string | null;
  pms_id?: string | null;
};

/**
 * Returns the source label for a property or unit based on its integration credentials and PMS ID.
 *
 * @param item - An object with optional integration_credential and pms_id properties
 * @returns The source label string
 */
export const getSourceLabel = (item?: SourceItem): string => {
  if (!item) return "Manually added";

  if (item.integration_credential) return item.integration_credential;

  if (item.pms_id) return "PMS";

  return "Manually added";
};
